import {gql} from "@apollo/client";

export const contentTopicsQuery = gql`
    query getContentTopicsQuery(
        $universitySlug: String
        $universityId: String
        $hideEmpty: Boolean
        $idIn: [String]
    ) {
        blogTopics(
            universitySlug: $universitySlug
            universityId: $universityId
            hideEmpty: $hideEmpty
            idIn: $idIn
        ) {
            id
            name
        }
    }
`;
